'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _useGetBoxResult = require('./useGetBoxResult');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_useGetBoxResult).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }